import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { url: String }

  async open() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"

    const response = await fetch(this.urlValue, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    const html = await response.text()
    window.Turbo.renderStreamMessage(html)
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }
}
